import { ToastError, ToastInfo, ToastSuccess } from "components/Global/Toasts/Toasty";
import _ from "lodash";
import moment from "moment";
import { takeLatest, call, put } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";
import { authorizedRequest } from "utils/api";

// ACTIONS
export const GET_REPORT_GROUPS_FOR_DEAL = generateDefaultActions("GET_REPORT_GROUPS_FOR_DEAL");
export const getReportGroupsForDeal = payload => makePayload(GET_REPORT_GROUPS_FOR_DEAL.value, payload);
function* getReportGroupsForDealSaga({ dealId }) {
  const url = `/report-groups/deal/${dealId}`;
  yield requestSaga(GET_REPORT_GROUPS_FOR_DEAL, url, "GET", null, null, null, true);
}

export const GET_REPORT_GROUP_BY_ID = generateDefaultActions("GET_REPORT_GROUP_BY_ID");
export const getReportGroupById = payload => makePayload(GET_REPORT_GROUP_BY_ID.value, payload);
function* getReportGroupByIdSaga({ reportGroupId }) {
  const url = `/report-groups/${reportGroupId}`;
  yield requestSaga(GET_REPORT_GROUP_BY_ID, url, "GET", null, null, null, true);
}

export const GET_FIELD_COUNT_FOR_DEAL = generateDefaultActions("GET_FIELD_COUNT_FOR_DEAL");
export const getFieldCountForDeal = payload => makePayload(GET_FIELD_COUNT_FOR_DEAL.value, payload);
function* getFieldCountForDealSaga({ dealId }) {
  const url = `/fields/deal/count/${dealId}`;
  yield requestSaga(GET_FIELD_COUNT_FOR_DEAL, url, "GET", null, null, null, true);
}

export const GET_SOURCE_FILE_COUNT_FOR_DEAL = generateDefaultActions("GET_SOURCE_FILE_COUNT_FOR_DEAL");
export const getSourceFileCountForDeal = payload => makePayload(GET_SOURCE_FILE_COUNT_FOR_DEAL.value, payload);
function* getSourceFileCountForDealSaga({ dealId }) {
  const url = `/source-files/deal/count/${dealId}`;
  yield requestSaga(GET_SOURCE_FILE_COUNT_FOR_DEAL, url, "GET", null, null, null, true);
}

export const GET_REPORT_COMPONENTS_FOR_REPORT_GROUP = generateDefaultActions("GET_REPORT_COMPONENTS_FOR_REPORT_GROUP");
export const getReportComponentsForReportGroup = payload => makePayload(GET_REPORT_COMPONENTS_FOR_REPORT_GROUP.value, payload);
function* getReportComponentsForReportGroupSaga({ reportGroupId }) {
  const url = `/report-components/report-group/${reportGroupId}`;
  yield requestSaga(GET_REPORT_COMPONENTS_FOR_REPORT_GROUP, url, "GET", null, null, null, true);
}

export const GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP = generateDefaultActions("GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP");
export const getProjectedReportComponentsForReportGroup = payload => makePayload(GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP.value, payload);
function* getProjectedReportComponentsForReportGroupSaga({ reportGroupId }) {
  const url = `/report-components/projected/report-group/${reportGroupId}`;
  yield requestSaga(GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP, url, "GET", null, null, null, true);
}

export const GET_PROJECTED_REPORT_GROUP_INSTANCES = generateDefaultActions("GET_PROJECTED_REPORT_GROUP_INSTANCES");
export const getProjectedReportGroupInstances = payload => makePayload(GET_PROJECTED_REPORT_GROUP_INSTANCES.value, payload);
function* getProjectedReportGroupInstancesSaga({ reportGroupId }) {
  const url = `/report-groups/instances/projected/${reportGroupId}`;
  yield requestSaga(GET_PROJECTED_REPORT_GROUP_INSTANCES, url, "GET", null, null, null, true);
}

export const GET_REPORT_GROUP_INSTANCES = generateDefaultActions("GET_REPORT_GROUP_INSTANCES");
export const getReportGroupInstances = payload => makePayload(GET_REPORT_GROUP_INSTANCES.value, payload);
function* getReportGroupInstancesSaga({ reportGroupId }) {
  const url = `/report-groups/instances/${reportGroupId}`;
  yield requestSaga(GET_REPORT_GROUP_INSTANCES, url, "GET", null, null, null, true);
}

export const GET_RGI_BY_ID = generateDefaultActions("GET_RGI_BY_ID");
export const getRgiById = payload => makePayload(GET_RGI_BY_ID.value, payload);
function* getRgiByIdSaga({ rgiId }) {
  const url = `/report-groups/instances/byId/${rgiId}`;
  yield requestSaga(GET_RGI_BY_ID, url, "GET", null, null, null, true);
}

export const GET_ALL_LOANS_FOR_DEAL = generateDefaultActions("GET_ALL_LOANS_FOR_DEAL");
export const getAllLoansForDeal = payload => makePayload(GET_ALL_LOANS_FOR_DEAL.value, payload);
function* getAllLoansForDealSaga({ dealId }) {
  const response = yield call(authorizedRequest, `/loans/getLoansByDealId/${dealId}`, "GET");
  yield put({ type: GET_ALL_LOANS_FOR_DEAL.success, payload: response.dealLoans });
}

export const DELETE_REPORT_CONFIG = generateDefaultActions("DELETE_REPORT_CONFIG");
export const deleteReportConfig = payload => makePayload(DELETE_REPORT_CONFIG.value, payload);
function* deleteReportConfigSaga({ id }) {
  const url = `/report-groups/${id}`;
  yield call(authorizedRequest, url, "DELETE", null, null, true);
  yield put({ type: DELETE_REPORT_CONFIG.success, payload: { reportConfigId: id } });
}

export const RECALCULATE_REPORT_GROUP_INSTANCE = generateDefaultActions("RECALCULATE_REPORT_GROUP_INSTANCE");
export const recalculateRgi = payload => makePayload(RECALCULATE_REPORT_GROUP_INSTANCE.value, payload);
function* recalculateRgiSaga({ reportGroupId, asOfDate, rgiType }) {
  const url = `/calculations/startCalculation/${reportGroupId}/${asOfDate}/${rgiType}`;
  yield requestSaga(RECALCULATE_REPORT_GROUP_INSTANCE, url, "GET", null, null, null, true);
}

export const TOGGLE_LOCK_RGI = generateDefaultActions("TOGGLE_LOCK_RGI");
export const toggleLockRgi = payload => makePayload(TOGGLE_LOCK_RGI.value, payload);
function* toggleLockRgiSaga({ rgi }) {
  const url = "/report-groups/instances";
  yield requestSaga(TOGGLE_LOCK_RGI, url, "PUT", rgi, null, null, true);
}

export const GET_CALCULATION_LOGS = generateDefaultActions("GET_CALCULATION_LOGS");
export const getCalculationLogs = payload => makePayload(GET_CALCULATION_LOGS.value, payload);
function* getCalculationLogsSaga({ reportGroupInstanceId }) {
  const url = `/report-groups/instances/logs/${reportGroupInstanceId}`;
  yield requestSaga(GET_CALCULATION_LOGS, url, "GET", null, null, null, true);
}

export const SET_LR_DASHBOARD_SELECTIONS = generateDefaultActions("SET_LR_DASHBOARD_SELECTIONS");
export const setDashboardSelections = payload => makeWritePayload(SET_LR_DASHBOARD_SELECTIONS.value, payload);

export const SET_DASHBOARD_SELECTIONS_TO_DEFAULT = generateDefaultActions("SET_DASHBOARD_SELECTIONS_TO_DEFAULT");
export const setDashboardSelectionsToDefault = payload => makeWritePayload(SET_DASHBOARD_SELECTIONS_TO_DEFAULT.value, payload);

export const GET_IS_PROJECTED_FALG_VALUE = generateDefaultActions("GET_IS_PROJECTED_FALG_VALUE");
export const getIsProjectedFlagValue = payload => makeWritePayload(GET_IS_PROJECTED_FALG_VALUE.value, payload);

export const actionCreators = {
  getFieldCountForDeal,
  getReportGroupsForDeal,
  getSourceFileCountForDeal,
  setDashboardSelections,
  getReportComponentsForReportGroup,
  getProjectedReportComponentsForReportGroup,
  getAllLoansForDeal,
  getReportGroupById,
  deleteReportConfig,
  recalculateRgi,
  getReportGroupInstances,
  getProjectedReportGroupInstances,
  toggleLockRgi,
  getRgiById,
  getCalculationLogs,
  setDashboardSelectionsToDefault,
  getIsProjectedFlagValue
};

// REDUCER
const initialState = {
  fieldCount: 0,
  initialDrawerSectionName: null,
  isLoading: false,
  isLenderReportingDrawerOpen: false,
  reportConfigs: null,
  sourceFileCount: 0,
  selectedReportGroup: null,
  reportComponentsForSelectedGroup: null,
  reportProjectedComponentsForSelectedGroup: null,
  allDealLoans: null,
  isRecalculating: false,
  reportGroupInstances: null,
  reportProjectedGroupInstances: null,
  rgiForPreview: null,
  isInstancesLoading: false,
  isRgiLoading: false,
  selectedRgiIdForLogs: null,
  calculationLogs: null,
  areLogsLoading: false,
  isProjected: false
};

export function lenderReportListReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_REPORT_GROUPS_FOR_DEAL.failure:
      ToastError("Failed to fetch existing reports.");

      return defaultReturn({ ...state, isLoading: false }, null, "reportConfigs");
    case GET_REPORT_GROUPS_FOR_DEAL.success:
      if (payload.data && !payload.data.length) {
        ToastInfo("There are no existing reports.");
      }

      return defaultReturn({ ...state, isLoading: false }, payload.data, "reportConfigs");
    case GET_REPORT_GROUPS_FOR_DEAL.value:
      return defaultReturn({ ...state, isLoading: true });

    case GET_REPORT_GROUP_BY_ID.failure:
      ToastError("Failed to fetch report group.");

      return defaultReturn({ ...state }, null, "selectedReportGroup");
    case GET_REPORT_GROUP_BY_ID.success:
      return defaultReturn({ ...state }, payload.data, "selectedReportGroup");
    case GET_REPORT_GROUP_BY_ID.value:
      return defaultReturn({ ...state });

    case GET_FIELD_COUNT_FOR_DEAL.failure:
      ToastError("Failed to fetch existing field count.");

      return defaultReturn({ ...state }, null, "fieldCount");
    case GET_FIELD_COUNT_FOR_DEAL.success:
      return defaultReturn({ ...state }, payload.count, "fieldCount");

    case GET_SOURCE_FILE_COUNT_FOR_DEAL.failure:
      ToastError("Failed to fetch existing source file count.");

      return defaultReturn({ ...state }, null, "sourceFileCount");
    case GET_SOURCE_FILE_COUNT_FOR_DEAL.success:
      return defaultReturn({ ...state }, payload.count, "sourceFileCount");

    case GET_REPORT_COMPONENTS_FOR_REPORT_GROUP.failure:
      ToastError("Failed to fetch existing report components.");

      return defaultReturn({ ...state }, null, "reportComponentsForSelectedGroup");
    case GET_REPORT_COMPONENTS_FOR_REPORT_GROUP.success:
      return defaultReturn({ ...state }, payload.data, "reportComponentsForSelectedGroup");
    case GET_REPORT_COMPONENTS_FOR_REPORT_GROUP.value:
      return defaultReturn({ ...state });

    case GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP.failure:
      ToastError("Failed to fetch existing report components.");

      return defaultReturn({ ...state }, null, "reportProjectedComponentsForSelectedGroup");
    case GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP.success:
      return defaultReturn({ ...state }, payload.data, "reportProjectedComponentsForSelectedGroup");
    case GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP.value:
      return defaultReturn({ ...state });

    case GET_REPORT_GROUP_INSTANCES.failure:
      ToastError("Failed to get reports.");

      return defaultReturn({ ...state, isInstancesLoading: false }, null, "reportGroupInstances");
    case GET_REPORT_GROUP_INSTANCES.success:
      return defaultReturn({ ...state, isInstancesLoading: false }, payload.data, "reportGroupInstances");
    case GET_REPORT_GROUP_INSTANCES.value:
      return defaultReturn({ ...state, isInstancesLoading: true });

    case GET_PROJECTED_REPORT_GROUP_INSTANCES.failure:
      ToastError("Failed to get projected reports.");

      return defaultReturn({ ...state, isInstancesLoading: false }, null, "reportProjectedGroupInstances");
    case GET_PROJECTED_REPORT_GROUP_INSTANCES.success:
      return defaultReturn({ ...state, isInstancesLoading: false }, payload.data, "reportProjectedGroupInstances");
    case GET_PROJECTED_REPORT_GROUP_INSTANCES.value:
      return defaultReturn({ ...state, isInstancesLoading: true });

      case GET_RGI_BY_ID.failure:
        ToastError("Failed to get the report.");

      return defaultReturn({ ...state, isRgiLoading: false }, null, "rgiForPreview");
    case GET_RGI_BY_ID.success:
      return defaultReturn({ ...state, isRgiLoading: false }, payload.data, "rgiForPreview");
    case GET_RGI_BY_ID.value:
      return defaultReturn(state, true, "isRgiLoading");

    case GET_ALL_LOANS_FOR_DEAL.failure:
      ToastError("Failed to fetch loans for deal.");

      return defaultReturn({ ...state }, null, "allDealLoans");
    case GET_ALL_LOANS_FOR_DEAL.success:
      return defaultReturn({ ...state }, payload, "allDealLoans");
    case GET_ALL_LOANS_FOR_DEAL.value:
      return defaultReturn({ ...state });

    case DELETE_REPORT_CONFIG.failure:
      ToastError("Could not delete the report group.");

      return defaultReturn(state, false, "isLoading");
    case DELETE_REPORT_CONFIG.success: {
      const filteredReportConfigs = state.reportConfigs && state.reportConfigs.filter(rc => rc.id !== payload?.reportConfigId);
      ToastSuccess("Report group has been successfully deleted.");

      return defaultReturn({ ...state, isLoading: false }, filteredReportConfigs, "reportConfigs");
    }
    case DELETE_REPORT_CONFIG.value:
      return defaultReturn(state, true, "isLoading");

    case RECALCULATE_REPORT_GROUP_INSTANCE.failure:
      ToastError("Failed to recalculate the report.");

      return defaultReturn(state, false, "isRecalculating");
    case RECALCULATE_REPORT_GROUP_INSTANCE.success: {
      ToastSuccess("Calculation has been successfully completed");
      const updatedRgis = state.reportGroupInstances && state.reportGroupInstances.map(rgi => (rgi.id === payload.data?.id ? payload.data : { ...rgi }));

      return defaultReturn({ ...state, isRecalculating: false }, updatedRgis, "reportGroupInstances");
    }
    case RECALCULATE_REPORT_GROUP_INSTANCE.value:
      return defaultReturn(state, true, "isRecalculating");

    case TOGGLE_LOCK_RGI.failure:
      ToastError("Failed to lock / unlock report.");

      return state;
    case TOGGLE_LOCK_RGI.success: {
      const updatedRgis = state.reportGroupInstances.map(rgi => (rgi.id === payload?.data.id ? payload?.data : rgi));

      return defaultReturn({ ...state }, updatedRgis, "reportGroupInstances");
    }

    case GET_CALCULATION_LOGS.failure:
      ToastError("Failed to get calculation logs.");

      return defaultReturn({ ...state, areLogsLoading: false, calculationLogs: null, selectedRgiIdForLogs: null });
    case GET_CALCULATION_LOGS.success:
      return defaultReturn(
        { ...state, areLogsLoading: false },
        _.orderBy(payload.data, l => moment(l.createdAt), "desc"),
        "calculationLogs"
      );
    case GET_CALCULATION_LOGS.value:
      return defaultReturn({ ...state, areLogsLoading: true });

    case SET_LR_DASHBOARD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DASHBOARD_SELECTIONS_TO_DEFAULT.value:
      return defaultReturn({ ...initialState });
    
    case GET_IS_PROJECTED_FALG_VALUE.value:
      return defaultReturn({ ...state });

    default:
      return state;
  }
}

// SAGA
export function* lenderReportListSaga() {
  yield takeLatest(GET_FIELD_COUNT_FOR_DEAL.value, getFieldCountForDealSaga);
  yield takeLatest(GET_REPORT_GROUPS_FOR_DEAL.value, getReportGroupsForDealSaga);
  yield takeLatest(GET_SOURCE_FILE_COUNT_FOR_DEAL.value, getSourceFileCountForDealSaga);
  yield takeLatest(GET_REPORT_COMPONENTS_FOR_REPORT_GROUP.value, getReportComponentsForReportGroupSaga);
  yield takeLatest(GET_PROJECTED_REPORT_COMPONENTS_FOR_REPORT_GROUP.value, getProjectedReportComponentsForReportGroupSaga);
  yield takeLatest(GET_ALL_LOANS_FOR_DEAL.value, getAllLoansForDealSaga);
  yield takeLatest(GET_REPORT_GROUP_BY_ID.value, getReportGroupByIdSaga);
  yield takeLatest(DELETE_REPORT_CONFIG.value, deleteReportConfigSaga);
  yield takeLatest(RECALCULATE_REPORT_GROUP_INSTANCE.value, recalculateRgiSaga);
  yield takeLatest(GET_REPORT_GROUP_INSTANCES.value, getReportGroupInstancesSaga);
  yield takeLatest(GET_REPORT_GROUP_INSTANCES.value, getProjectedReportGroupInstancesSaga);
  yield takeLatest(TOGGLE_LOCK_RGI.value, toggleLockRgiSaga);
  yield takeLatest(GET_RGI_BY_ID.value, getRgiByIdSaga);
  yield takeLatest(GET_CALCULATION_LOGS.value, getCalculationLogsSaga);
}
